export default __webpack_public_path__ + "static/media/3_zerohiddenfees.b5379aec.svg";